// UI overlay for unfinished wizard tasks — not a backend usecase.status.
export const draft = "Draft"
export const waiting_for_prompt_and_teacher = "Waiting for Prompt and Teacher"
export const waiting_for_data = "Waiting for Data"
export const gathering_data = "Gathering Data"
export const ready_for_distillation = "Ready for Distillation"
export const distillation_in_progress = "Distillation in Progress"
export const evaluation_in_progress = "Evaluation in Progress"
export const ready_to_deploy = "Ready to Deploy"
export const deploy_in_progress = "Deploy in Progress"
export const deployed = "Deployed"
export const undeploy_in_progress = "Undeploy in Progress"